/**
 * OCU Forms Event Listeners
 * Tracks which form was submitted for Zipify OCU integration
 * Updates window.selectedOCUForm on form submission
 */

document.addEventListener('DOMContentLoaded', function() {
  // Variant 1 Form - Single Bottle (OTP)
  const form1 = document.getElementById('custom-add-to-cart-form-variant1');
  if (form1) {
    form1.addEventListener('submit', function(e) {
      window.selectedOCUForm = this;
    });
  }

  // Variant 2 Form - 3-Pack (OTP)
  const form2 = document.getElementById('custom-add-to-cart-form-variant2');
  if (form2) {
    form2.addEventListener('submit', function(e) {
      window.selectedOCUForm = this;
    });
  }

  // Variant 1 Subscription Form - Single Bottle
  const form1Sub = document.getElementById('custom-add-to-cart-form-variant1-subscription');
  if (form1Sub) {
    form1Sub.addEventListener('submit', function(e) {
      window.selectedOCUForm = this;
    });
  }

  // Variant 2 Subscription Form - 30 Days
  const form2Sub30 = document.getElementById('custom-add-to-cart-form-variant2-subscription-30');
  if (form2Sub30) {
    form2Sub30.addEventListener('submit', function(e) {
      window.selectedOCUForm = this;
    });
  }

  // Variant 2 Subscription Form - 90 Days
  const form2Sub90 = document.getElementById('custom-add-to-cart-form-variant2-subscription-90');
  if (form2Sub90) {
    form2Sub90.addEventListener('submit', function(e) {
      window.selectedOCUForm = this;
    });
  }
});
